export default "__VITE_ASSET__7218b482__"